/**
 * 公共正则   此文件不允许改动，若有改动，联系李剑|18363003321
 * lijian
 * 每个前端，直接复制使用
 */
import Vue from 'vue'

var regular = {
  // 不能特殊字符
  specialCharacters: new RegExp("[.`~!@$^&*=|{}';',\\[\\]《》/~！@#￥……&*{}【】‘；：”“'。，？' ']"),
  // 校验姓名
  realNameRegular: /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/,
  // 校验手机号
  mobile: /^1[3|4|5|7|8][0-9]\d{8}$/
}
Vue.prototype.commonRegular = regular
export default regular

